import styled from 'styled-components';
import { BREAKPOINTS } from 'constants/breakpoints';

const RowContainer = styled.div`
  display: flex;
  flex-direction: row;
  padding-bottom: 20px;
  &.margin {
    margin-bottom: 20px;
  }
`;

const ColumnContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 80%;
  &.left-padding {
    margin-left: 20px;
  }

  @media (max-width: ${`${BREAKPOINTS.lg.max}px`}) {
    width: 100%;
  }
`;

export { RowContainer, ColumnContainer };
